
        import type { DefaultTemplateRootProps, TemplateResult } from 'Components/types';
type fitmentTableTabRTRootProps = DefaultTemplateRootProps;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function fitmentTableTabRT(): TemplateResult<fitmentTableTabRTRootProps> {
    return this.vehicleSpecific || this.manyFitments ? _createElement('span', { 'key': '0' }, 'VEHICLE FITMENT') : null;
}
        export const componentNames = []